import { REACT_APP__BASE_PATH } from "@smp/utils";

export const config = {
  baseRoute: `/new_posts/feed`,
  dialogRoute: `${REACT_APP__BASE_PATH}/post_v3`,
  placeLastUsedStorageKey: "easypostUserStorage.placeService.lastUsed",
  scheduleNowOffset: 1, // minutes
  mediaAccepts:
    "image/gif, image/jpg, image/jpeg, image/png, image/svg, image/webp, video/*",
  saveFormStateToStorageDelay: 500,
  tenchatMaxTopicsNum: 3,
  mediaPreviewSize: 256,
};
